module.exports = __webpack_public_path__ + "img/logo-home.1c845a40.png";